export default __webpack_public_path__ + "static/media/Nose_1.c4465f11.svg";